// constants.js
const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

window.merakiUtils = {
  metaPixelId: '1261846338235188',
  isLoadedAfterFirstScreen: false, // 未加载资源
  lazyImages: Array.from(document.querySelectorAll('img.lazy-load[data-src]')),
  lazyVideos: Array.from(document.querySelectorAll('video.lazy-video-load')),
  lazyYoutubeVideos: Array.from(document.querySelectorAll('iframe.lazy-youtube-load')),
  loadThreshold: 1500, // 提前1500px加载，提升体验
  submitCountryForm: function (country = '', returnHref = '', locale_code = '', currencyCode = '') {
    // 通过 shopify 内部 api 的 /localization 实现跳转
    // 通过 form 表单实现跳转
    const subSiteCountrys = ['AT', 'DE'];
    let host = 'https://eu.merakitech.com'
    if (subSiteCountrys.includes(country)) host = 'https://de.merakitech.com';
    const host_local = '/localization'
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = `${host}${host_local}`;
    form.acceptCharset = 'UTF-8';
    form.style.display = 'none';

    // const HeaderCountryFormDom = document.querySelector('#HeaderCountryForm')
    // if (HeaderCountryFormDom) {
    //   const formAction = HeaderCountryFormDom.getAttribute('action');
    //   if (formAction) {
    //     form.action = `${host}${formAction}`;
    //   }
    // }

    returnHref = this.formatReturnHref(returnHref, country, currencyCode, true)

    const formData = [
      { name: 'form_type', value: 'localization' },
      { name: 'utf8', value: '✓' },
      { name: '_method', value: 'put' },
      { name: 'return_to', value: returnHref },
      { name: 'country_filter', value: '' },
      { name: 'country_code', value: country },
      { name: 'locale_code', value: locale_code }
    ];

    formData.forEach(item => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = item.name;
      input.value = item.value;
      form.appendChild(input);
    });

    document.body.appendChild(form);

    form.submit();
    setTimeout(() => document.body.removeChild(form), 100);
  },
  /**
   * 获取cookie值
   * @param {string} key cookie键名
   * @returns {string|null} 返回值，不存在返回null
   */
  getCookie: function (key) {
    const name = key + "=";
    const cookieArr = document.cookie.split(';');
    for(let item of cookieArr) {
      item = item.trim();
      if(item.startsWith(name)) {
        return item.substring(name.length);
      }
    }
    return null;
  },
  formatReturnHref: function (returnHref = '', country = '', currencyCode = '', isExternalRedirect = false) {
    const recordReturnHref = returnHref;
    let isBlank = false;

    // 特殊，由于EU站点没有当前页面，所以默认调整到首页
    // const euNoPages = ['pages/home-espresso-ritual'];
    const euNoPages = [];
    if (isBlank && euNoPages.some((item) => recordReturnHref.includes(item))) {
      returnHref = '/'
    }

    let entryParams = '?utm_source=merakitech.com&utm_medium=referral&utm_campaign=geo_redirect';

    // 获取impact保存到cookie中的irclickid数据，但是需要在切换到其它站点时，才会传递这个参数
    if (window.merakiUtils && window.merakiUtils.getCookie) {
      const irclickid = window.merakiUtils.getCookie('irclickid');
      if (irclickid) {
        entryParams += `&im_ref=${irclickid}`;
      }
    }

    if (isExternalRedirect) {
      isBlank = true;
      returnHref += entryParams;
    }

    return returnHref;
  },
  // 过滤重定向链接，应为有些地区的同一个产品的链接不一样，需要进行处理
  filterRedirectPath: function (redirectPath = '') {
    redirectPath = redirectPath.replace(window.Shopify.routes.root, '/')
    return redirectPath
  },
  loadVisibleResource: function () {
    // 懒加载资源
    window.merakiUtils.lazyImages.forEach(img => {
      if (img.classList.contains('lazy-load')) {
        if (window.merakiUtils.mediaLazyObserver) {
          window.merakiUtils.mediaLazyObserver.observe(img);
        }
      }
    });

    window.merakiUtils.lazyVideos.forEach(video => {
      if (video.classList.contains('lazy-video-load')) {
        if (window.merakiUtils.mediaLazyObserver) {
          window.merakiUtils.mediaLazyObserver.observe(video);
        }
      }
    });

    window.merakiUtils.lazyYoutubeVideos.forEach(video => {
      if (video && video.classList.contains('lazy-youtube-load')) {
        if (window.merakiUtils.mediaLazyObserver) {
          window.merakiUtils.mediaLazyObserver.observe(video);
        }
      }
    });
  },
  isHidden: function (el) {
    if (!el || el.nodeType !== 1) return false;
    if (window.getComputedStyle(el).display === 'none' || window.getComputedStyle(el).visibility === 'hidden' || parseFloat(window.getComputedStyle(el).opacity) === 0) return true;
    return el.parentNode ? this.isHidden(el.parentNode) : false;
  },
  // 节流函数：降低scroll触发频率（每200ms执行一次）
  throttle: function (fn, delay = 200) {
    let timer = null;
    return function() {
      if (!timer) {
        timer = setTimeout(() => {
          fn.apply(this, arguments);
          timer = null;
        }, delay);
      }
    };
  },
  // 加载单张图片
  loadImage: function (img) {
    const isNone = window.getComputedStyle(img).display === 'none';
    if (!isNone) {
      const pictureNode = img.closest('picture')
      if (pictureNode) {
        const sources = pictureNode.querySelectorAll('source')
        if (sources && sources.length > 0) {
          sources.forEach((source) => {
            const srcset = source.getAttribute('data-srcset');
            if (srcset) {
              source.srcset = source.getAttribute('data-srcset');
              source.removeAttribute('data-srcset');
            }
          })
        }
      }

      img.src = img.getAttribute('data-src');
      const srcset = img.getAttribute('data-srcset');
      if (srcset) {
        img.srcset = srcset;
        img.removeAttribute('data-srcset');
      }
      img.removeAttribute('data-src');
      img.classList.remove('lazy-load');
    }
    // 添加加载完成动画
    // img.style.opacity = '1';
  },
  // 加载单个视频
  loadVideo: function (videoDom) {
    const isNone = window.getComputedStyle(videoDom).display === 'none';
    if (!isNone) {
      videoDom.poster = videoDom.getAttribute('data-poster');
      const sourceDom = videoDom.querySelector('source')
      if (sourceDom) {
        sourceDom.src = sourceDom.getAttribute('data-src');
        videoDom.load()
      }
      videoDom.removeAttribute('data-poster');
      videoDom.classList.remove('lazy-video-load');
    }
  },
  // 加载单个youtube视频
  loadYoutubeVideo: function (videoDom) {
    const isNone = window.getComputedStyle(videoDom).display === 'none';
    if (!isNone) {
      videoDom.src = videoDom.getAttribute('data-youtube-lazy-src');
      videoDom.removeAttribute('data-youtube-lazy-src');
      videoDom.classList.remove('lazy-youtube-load');
    }
  },
  // 首屏以后再加载资源
  loadResourceAfterFirstScreen: function () {
    if (window.merakiUtils.isLoadedAfterFirstScreen) return;
    // 当前滚动距离（兼容不同浏览器）
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

    if (scrollTop < 50) return;

    // 判定：滚动过首屏 + 未加载过资源
    if (!window.merakiUtils.isLoadedAfterFirstScreen) {
      window.merakiUtils.isLoadedAfterFirstScreen = true;

      window.dispatchEvent(new CustomEvent("CustomLoad"));

      document.querySelectorAll("script[type='text/lazyload']").forEach(originalScript => {
        const newScript = document.createElement('script');
        if (originalScript.dataset.src) {
          newScript.src = originalScript.dataset.src;
        }
        for (const attr of originalScript.attributes) {
          if (attr.name !== 'type' && attr.name !== 'data-src') {
            newScript.setAttribute(attr.name, attr.value);
          }
        }
        newScript.type = originalScript.dataset.type || 'text/javascript';
        originalScript.parentNode.replaceChild(newScript, originalScript);
      });
      const lazyScriptdDom = document.querySelectorAll('[data-script-src]');
      lazyScriptdDom.forEach(scriptSrc => {
        scriptSrc.src = scriptSrc.getAttribute('data-script-src');
        scriptSrc.removeAttribute('data-script-src');
      });

      // (function(c,l,a,r,i,t,y){
      //   c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
      //   t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
      //   y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      // })(window, document, "clarity", "script", "rn0xle6wx3");

      // const shopify_pc__banner__dialogDom = document.querySelector('.shopify-pc__banner__dialog');
      // if (shopify_pc__banner__dialogDom) {
      //   shopify_pc__banner__dialogDom.style.display = 'block';
      // };
    }
  },
  // 瞄点跳转
  scrollToAnchor: function () {
    // 导航高度（根据店铺固定导航调整，避免遮挡锚点）
    const currentHash = window.location.hash
    if (!currentHash) return;
    const navHeight = document.querySelector('.header').innerHeight || 120;
    // 多次尝试查找目标元素（适配动态加载）
    const maxAttempts = 10; // 最多尝试10次
    let attempts = 0;
    let timer = null
    const checkAndScroll = () => {
      clearTimeout(timer)
      attempts++;
      const target = document.querySelector(currentHash);
      if (target) {
        // 跳转到锚点，避开导航遮挡
        window.scrollTo({
          top: target.offsetTop - navHeight,
          behavior: 'smooth' // 平滑滚动，可选
        });
        return;
      }
      // 未找到目标元素，继续尝试（每200ms一次）
      if (attempts < maxAttempts) {
        timer = setTimeout(checkAndScroll, 200);
      }
    };
    checkAndScroll()
  },
  regionSelectorKey: 'region-selector-success',
  regionSelectorTimeKey: 'region-selector-time',
  localStorageSet (value = 'true') {
    localStorage.setItem(window.merakiUtils.regionSelectorKey, value) 
    localStorage.setItem(window.merakiUtils.regionSelectorTimeKey, Date.now()) 
  },
  clearExpiredLocalStorage (TWO_DAYS = 2 * 24 * 60 * 60 * 1000) {
    const now = Date.now();
    const cacheStrKey = localStorage.getItem(window.merakiUtils.regionSelectorKey);
    const cacheStr = localStorage.getItem(window.merakiUtils.regionSelectorTimeKey);
    if ((!cacheStr || !cacheStrKey) || cacheStr && now - cacheStr > TWO_DAYS) {
      localStorage.removeItem(window.merakiUtils.regionSelectorKey);
      localStorage.removeItem(window.merakiUtils.regionSelectorTimeKey);
      return true
    }
    return false
  },
  // 自动弹出地区选择器
  autoOpenRegionSelector () {
    if (!window.merakiUtils.clearExpiredLocalStorage || !window.merakiUtils.clearExpiredLocalStorage()) return false

    let width;
    if (window.innerWidth) {
      width = window.innerWidth;
    } 
    else if (document.documentElement && document.documentElement.clientWidth) {
      width = document.documentElement.clientWidth;
    } 
    else if (document.body) {
      width = document.body.clientWidth;
    }
    if (window.innerWidth && document.documentElement.clientWidth) {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      width = width - scrollbarWidth;
    }

    if (width > 1100) {
      if (window.openLocaleModal) {
        window.openLocaleModal()
      }
    } else {
      if (window.mobileModalInstance && window.mobileModalInstance.localeSelectorModalTrigger) {
        window.mobileModalInstance.localeSelectorModalTrigger.click()
      }
    }
  },
  // sessionStorage 的添加读取
  meta_session_view_pillar: "Pillar_to_PDP_Click",
  sessionStorageSet (key = '', value = 'true') {
    sessionStorage.setItem(key, value) 
  },
  sessionStorageGet (key = '') {
    return sessionStorage.getItem(key)
  },
  // 全局绑定 IntersectionObserver 实例,用于懒加载组件
  lazyObserver: (() => {
    let observer = null;

    const createObserver = () => {
      // 配置项：rootMargin提前N px触发（元素即将进入视口时就初始化，无感知）
      const ViewportHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
      const observerOptions = {
        root: null, // 根容器为视口（document.viewport）
        rootMargin: `${ViewportHeight * 0.3}px 0px`, // 上下各扩展50px，提前/延后判断
        threshold: 0 // 元素只要有1px进入视口就触发回调
      };
      return new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const component = entry.target;
            // 执行组件初始化
            if (typeof component.init === 'function') {
              component.init();
            }
            // 初始化后取消观察（只执行一次）
            observer.unobserve(component);
          }
        });
      }, observerOptions);
    }

    return {
      observe(component) {
        if (!observer) observer = createObserver();
        observer.observe(component)
      }
    }
  })(),
  // 用于媒体懒加载
  mediaLazyObserver: (() => {
    let observer = null;
    const createObserver = () => {
      const preloadMargin = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      const MAX_MARGIN = preloadMargin ? preloadMargin * 1 : 1500;
      // 配置项：rootMargin提前N px触发（元素即将进入视口时就初始化，无感知）
      const observerOptions = {
        rootMargin: `${MAX_MARGIN}px 0px ${MAX_MARGIN}px 0px` // 上下各扩展50px，提前/延后判断
      };
      return new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const target = entry.target;
            if (window.merakiUtils.isHidden(target)) return;
            if (target.classList.contains('lazy-load')) {
              window.merakiUtils.loadImage(target);
              observer.unobserve(target);
            } else if (target.classList.contains('lazy-video-load')) {
              window.merakiUtils.loadVideo(target);
              observer.unobserve(target);
            } else if (target.classList.contains('lazy-youtube-video-load')) {
              window.merakiUtils.loadYoutubeVideo(target);
              observer.unobserve(target);
            }
          }
        });
      }, observerOptions);
    }

    return {
      observe(component) {
        if (!observer) observer = createObserver();
        observer.observe(component)
      }
    }
  })(),

  // 把时间转为美西时间（美国洛杉矶）
  formatterTime (date) {
    const formatter = date.toLocaleString('en-US', {
      timeZone: 'America/Los_Angeles',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    })

    return formatter.replace(/24:/, '00:')
  },
  // 通过时间戳返回 天、时、分、秒
  useTimeRemaining (timestamp = 0) {
    let seconds = Math.floor(timestamp / 1000)
    // const days = Math.floor(seconds / (24 * 3600))
    // seconds %= 24 * 3600
    const hours = Math.floor(seconds / 3600)
    seconds %= 3600
    const minutes = Math.floor(seconds / 60)
    seconds %= 60

    // const dd = String(days).padStart(2, '0');
    const hh = String(hours).padStart(2, '0');
    const mm = String(minutes).padStart(2, '0');
    const ss = String(seconds).padStart(2, '0');

    return {
      // dd,
      hh,
      mm,
      ss
    }
  },
  // 获取元素相对 document 的顶部位置（不依赖 getBoundingClientRect，避免 iOS Safari 地址栏导致 rect 变化）
  getDocumentTop(el) {
    let top = 0;
    let node = el;
    while (node) {
      top += node.offsetTop || 0;
      node = node.offsetParent;
    }
    return top;
  },
  // 封装全局监听可视窗口变化 + 多组件共用
  viewportResize: (() => {
    // 订阅回调列表
    const subscribers = [];
    let timer = null;
    // 全局只绑定一次 resize
    window.addEventListener('resize', () => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        handleResize();
      }, 100); // 防抖间隔 100ms
    });
    // 触发所有订阅者
    function handleResize() {
      const viewWidth = document.documentElement.clientWidth;
      const viewHeight = document.documentElement.clientHeight;
      // 把宽高传给每一个订阅回调
      subscribers.forEach(cb => {
        cb({ viewWidth, viewHeight });
      });
    }
    return {
      subscribe(callback) {
        subscribers.push(callback)
      },
      unsubscribe() {
        const index = subscribers.indexOf(callback);
        if (index > -1) {
          subscribers.splice(index, 1);
        }
      }
    }
  })(),
  nowData: Date.now(),
  // 生成 16 位随机字符串（包含 - ）
  generateSecure16BitRandomStr() {
    const charPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const charPoolLength = charPool.length;
    const length = 16;
    let randomStr = '';
    const randomArray = new Uint32Array(length);
    window.crypto.getRandomValues(randomArray);
    for (let i = 0; i < length; i++) {
      const randomIndex = randomArray[i] % charPoolLength;
      randomStr += charPool[randomIndex];
    }
    return randomStr + '-' + window.merakiUtils.nowData;
  },
  /**
   * 获取当前产品（变体）加购时应当附带的赠品配件及其数量。
   *
   * 数据来源（均为页面内嵌 <script> 标签中的 JSON）：
   *   - #shop-product-gift-accessory : 「主产品 ↔ 赠品配件」的绑定关系配置
   *       结构：[{ product_variants: [{ variant_id, ... }], gift_accessorys: [{ gift_accessory_variants: [{ variant_id, available }] }] }]
   *   - #shop-cart                    : 当前购物车中的所有商品行
   *       结构：[{ variant_id, quantity, key }]
   *
   * 核心规则：让「赠品配件数量」始终对齐「主产品在购物车中的总数量」，
   *           即主产品买 N 个，赠品配件也应当是 N 个。
   *
   * @param {number|string} productId 产品 id（当前实现未实际使用，仅作预留）
   * @param {number|string} variantId 产品变体 id（实际用于匹配赠品绑定关系的维度）
   * @param {boolean}       isBuyNow  是否为「立即购买」场景（当前实现未使用，仅作预留）
   * @param {number|string} quantity  本次要加购的数量，默认 1
   * @returns {Array<{ id: string, quantity: number }>} 需要附带加购的赠品配件列表
   *         形如 [{ id: "456", quantity: 2 }]；无匹配或无配置时返回空数组 []
   */
  getShopGiftAccessory({ productId, variantId, isBuyNow = false, quantity = 1 }) {
    // 读取页面内嵌 <script> 标签中的 JSON 数据，缺失或解析失败时返回 null
    const readScriptJson = (elementId) => {
      const element = document.getElementById(elementId);
      if (!element?.textContent) return null;
      try {
        return JSON.parse(element.textContent);
      } catch {
        return null;
      }
    };

    const giftAccessoryConfigs = readScriptJson('shop-product-gift-accessory');
    const cartItems = readScriptJson('shop-cart');

    if (!Array.isArray(giftAccessoryConfigs) || !giftAccessoryConfigs.length) return [];

    // 命中当前变体的「主产品 → 赠品配件」绑定配置
    const matchedConfigs = giftAccessoryConfigs.filter((config) =>
      config.product_variants?.some(
        (variant) => String(variant.variant_id) === String(variantId)
      )
    );

    // 主产品总数 = 本次加购数量 + 购物车中已存在的主产品数量
    let totalQuantity = Number(quantity);
    matchedConfigs.forEach((config) => {
      (config.product_variants || []).forEach((variant) => {
        const cartItem = cartItems.find(
          (item) => String(item.variant_id) === String(variant.variant_id)
        );
        if (cartItem) totalQuantity += Number(cartItem.quantity);
      });
    });

    // 统计某变体在购物车中已有的总数量
    const countVariantInCart = (variantId) =>
      cartItems.reduce(
        (sum, item) =>
          String(item.variant_id) === String(variantId)
            ? sum + Number(item.quantity)
            : sum,
        0
      );

    // 逐个赠品配件计算应加购的数量
    return matchedConfigs.reduce((result, config) => {
      (config.gift_accessorys || []).forEach((accessory) => {
        // 取第一个「可售」的赠品变体作为加购对象
        const availableVariant = (accessory.gift_accessory_variants || []).find(
          (variant) => variant.available
        );
        if (!availableVariant) return;

        // 已有赠品不足主产品总数时补足差额，否则不加购（等效于原来的三路分支）
        const existingQuantity = countVariantInCart(availableVariant.variant_id);
        const addQuantity = Math.max(totalQuantity - existingQuantity, 0);

        result.push({ id: String(availableVariant.variant_id), quantity: addQuantity });
      });
      return result;
    }, []);
  },
  /**
   * 更新购物车中某一行商品的数量，并按「赠品数量对齐主产品数量」的规则联动重算相关赠品配件。
   *
   * 数据来源（均为页面内嵌 <script> 标签中的 JSON）：
   *   - #shop-product-gift-accessory : 「主产品 ↔ 赠品配件」绑定配置
   *   - #shop-cart                   : 当前购物车行数组 [{ variant_id, quantity, key }]
   *
   * 核心规则：赠品数量始终对齐其绑定的主产品数量（主产品买 N 个，赠品也 N 个）。
   * 修改购物车某行时，需要区分「改的是主产品」还是「改的是赠品配件本身」两种角色：
   *   - 场景 A「改主产品」  ：被改变体是某配置的主产品 → 其绑定的所有赠品数量强制对齐新的主产品总数。
   *   - 场景 B「改赠品配件」：被改变体是赠品 → 同一主产品下的其它赠品数量跟随对齐，但不超过主产品总数。
   *
   * @param {number} line     购物车行号（从 1 开始）
   * @param {number} quantity 修改后的目标数量
   * @returns {Promise<number|null>} 更新后「当前商品」所处的新行号；无法确定时返回 null
   */
  updateCartLine(line, quantity) {
    return new Promise(async (resolve) => {
      // 读取页面内嵌 <script> 中的 JSON，缺失或解析失败时返回 null
      const readScriptJson = (elementId) => {
        const element = document.getElementById(elementId);
        if (!element?.textContent) return null;
        try { return JSON.parse(element.textContent); } catch { return null; }
      };

      try {
        const giftAccessoryConfigs = readScriptJson('shop-product-gift-accessory');
        const cartItems = readScriptJson('shop-cart');

        if (!Array.isArray(giftAccessoryConfigs) || !Array.isArray(cartItems) || Number(line) <= 0) {
          resolve(null);
          return;
        }

        // 被修改的那一行
        const currentCartItem = cartItems[Number(line) - 1];
        if (!currentCartItem) { resolve(null); return; }

        // 以 variant_id 为键聚合购物车行：quantity = 该变体总数量，keys = 该变体所有行的 key
        const variantMap = new Map();
        cartItems.forEach((item) => {
          const id = String(item.variant_id);
          const aggregated = variantMap.get(id);
          if (aggregated) {
            aggregated.quantity += Number(item.quantity);
            aggregated.keys.push(item.key);
          } else {
            variantMap.set(id, { quantity: Number(item.quantity), keys: [item.key] });
          }
        });

        const currentVariantId = currentCartItem.variant_id;
        // 本次修改使该变体净增/净减的数量（可正可负）
        const quantityChange = Number(quantity) - Number(currentCartItem.quantity);

        // 角色一：当前变体作为「主产品」的配置
        const mainProductConfigs = giftAccessoryConfigs.filter((config) =>
          config.product_variants?.some((v) => String(v.variant_id) === String(currentVariantId))
        );
        // 角色二：当前变体作为「赠品配件」被绑定的配置
        const giftBindingConfigs = giftAccessoryConfigs.filter((config) =>
          config.gift_accessorys?.some((accessory) =>
            accessory.gift_accessory_variants?.some((v) => String(v.variant_id) === String(currentVariantId))
          )
        );

        // 记录需要更新数量的赠品变体（去重）
        const giftVariantIdsToUpdate = [];
        const markGiftVariant = (variantId) => {
          const id = String(variantId);
          if (!giftVariantIdsToUpdate.includes(id)) giftVariantIdsToUpdate.push(id);
        };

        if (mainProductConfigs.length) {
          // 场景 A：改的是主产品 → 其绑定的所有赠品数量对齐新的主产品总数
          mainProductConfigs.forEach((config) => {
            // 主产品（含所有变体）改动后的购物车总数量
            let newQuantity = 0;
            cartItems.forEach((cartItem) => {
              config.product_variants?.forEach((variant) => {
                if (String(variant.variant_id) !== String(cartItem.variant_id)) return;
                newQuantity +=
                  Number(cartItem.quantity) +
                  (String(cartItem.variant_id) === String(currentVariantId) ? quantityChange : 0);
              });
            });

            config.gift_accessorys?.forEach((accessory) => {
              accessory.gift_accessory_variants?.forEach((variant) => {
                variantMap.get(String(variant.variant_id)).quantity = newQuantity;
                markGiftVariant(variant.variant_id);
              });
            });
          });
        } else if (giftBindingConfigs.length) {
          // 场景 B：改的是赠品配件 → 其它赠品跟随当前赠品对齐，但不超过主产品总数
          // ① 绑定的主产品总数（赠品数量的「天花板」）
          let boundProductQuantity = 0;
          giftBindingConfigs.forEach((config) => {
            cartItems.forEach((cartItem) => {
              config.product_variants?.forEach((variant) => {
                if (String(variant.variant_id) === String(cartItem.variant_id)) {
                  boundProductQuantity += Number(cartItem.quantity);
                }
              });
            });
          });

          // ② 当前被改赠品的新总数量
          const currentGiftQuantity =
            variantMap.get(String(currentVariantId)).quantity + quantityChange;

          // ③ 联动更新其它赠品
          giftBindingConfigs.forEach((config) => {
            config.gift_accessorys?.forEach((accessory) => {
              accessory.gift_accessory_variants?.forEach((variant) => {
                if (String(variant.variant_id) === String(currentVariantId)) return; // 跳过当前赠品本身
                const aggregated = variantMap.get(String(variant.variant_id));
                if (!aggregated) return;
                if (aggregated.quantity > boundProductQuantity) {
                  if (currentGiftQuantity === 0) {
                    aggregated.quantity = 0;
                    markGiftVariant(variant.variant_id);
                  }
                  return; // 已超过天花板，保持原样
                }
                aggregated.quantity =
                  currentGiftQuantity >= boundProductQuantity
                    ? boundProductQuantity
                    : currentGiftQuantity;
                markGiftVariant(variant.variant_id);
              });
            });
          });
        }

        // 把待更新的赠品映射为「按行 key」的更新对象：
        // 同一变体多行时数量集中到第一行，其余行归 0（等价于合并成一行）
        const cartUpdates = {};
        giftVariantIdsToUpdate.forEach((variantId) => {
          const { keys, quantity } = variantMap.get(variantId);
          keys.forEach((key, index) => {
            cartUpdates[key] = index === 0 ? quantity : 0;
          });
        });

        if (!Object.keys(cartUpdates).length) { resolve(null); return; }

        // 批量更新后行号会重排，需按变体 id 重新定位当前商品的新行号
        const updatedItems = await window.merakiUtils.updateCartQuantity(cartUpdates);
        if (!updatedItems?.length) { resolve(null); return; }

        // const index = updatedItems.findIndex((item) => parseInt(item.id) === parseInt(currentVariantId));
        const index = updatedItems.findIndex((item) => item.key === currentCartItem.key);
        resolve(index !== -1 ? index + 1 : null);
      } catch (error) {
        console.log('updateCartLine');
        console.log(error);
        resolve(null);
      }
    });
  },
  /**
   * 批量更新购物车中的商品数量
   */
  updateCartQuantity(items) {
    return new Promise((resolve, reject) => {
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.headers['Content-Type'] = 'application/json';
      fetch(routes.cart_update_url, {
        ...config,
        body: JSON.stringify({ updates: items })
      }).then((response) => {
        return response.json();
      })
      .then((res) => {
        if (res && res.items && res.items.length) {
          resolve(res.items);
          return;
        }
        resolve(null);
      }).catch(() => {
        resolve(null);
      })
    })
  },
  /**
   * 切换变体时，更新id为mrk-sticky-bar的html内容。
   * @param {*} url 
   * @param {*} optionId 
   * @returns 
   */
  renderStickyBarHtml(url, optionId) {
    if (!url || !optionId) return;
    const stickyBarNode = document.querySelector('#mrk-sticky-bar');
    if (!stickyBarNode) return;
    if (stickyBarNode.dataset.jsUpdate !== 'true') return;
    const sectionId = stickyBarNode.dataset.sectionId;
    if (!sectionId) return;

    const params = [];
    const sections = [sectionId];
    params.push(`sections=${sections.join(',')}`);
    params.push(`option_values=${optionId}`);
    const RequestUrlWithParams = `${url}?${params.join("&")}`;

    fetch(RequestUrlWithParams, {})
      .then((response) => response.text())
      .then((responseText) => {
        return responseText;
      })
      .then((res) => {
        if (!res) return;
        const jsonRes = JSON.parse(res);
        if (!jsonRes[sectionId]) return;
        const stickyBarHtml = new DOMParser().parseFromString(jsonRes[sectionId], "text/html");
        const priceAttr = '[data-price-node]';
        const newHtmlNode = stickyBarHtml.querySelector(priceAttr);
        const htmlNode = stickyBarNode.querySelector(priceAttr);
        htmlNode.innerHTML = newHtmlNode.innerHTML;

        const addCartAttr = '[data-add-cart-node]';
        const newAddCartHtmlNode = stickyBarHtml.querySelector(addCartAttr);
        const addCartHtmlNode = stickyBarNode.querySelector(addCartAttr);
        if (addCartHtmlNode.parentNode) {
          addCartHtmlNode.parentNode.replaceChild(newAddCartHtmlNode, addCartHtmlNode);
        }
      })
      .catch((error) => {
        console.log("sticky bar", error);
      });
  }
}

// pubsub.js
let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    const promises = subscribers[eventName]
      .map((callback) => callback(data))
    return Promise.all(promises);
  } else {
    return Promise.resolve()
  }
}

// global.js
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

class SectionId {
  static #separator = "__";

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(
    oldNode,
    newContent,
    preProcessCallbacks = [],
    postProcessCallbacks = [],
  ) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement("div");
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll("[id], [form]").forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form &&
        element.setAttribute(
          "form",
          `${element.form.getAttribute("id")}-${uniqueKey}`,
        );
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = "none";

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll("script").forEach((oldScriptTag) => {
      const newScriptTag = document.createElement("script");
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  if (elementToFocus) {
    elementToFocus.focus();
  
    if (
      elementToFocus.tagName === "INPUT" &&
      ["search", "text", "email", "url"].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  }
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*",
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this),
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === "plus" || event.currentTarget.name === "plus") {
      if (
        parseInt(this.input.dataset.min) > parseInt(this.input.step) &&
        this.input.value == 0
      ) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (
      this.input.dataset.min === previousValue &&
      event.target.name === "minus"
    ) {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle(
        "disabled",
        parseInt(value) <= parseInt(this.input.min),
      );
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll(
      "button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button):not(.meraki-locale-mobile-trigger)",
    ).forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this)),
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary"),
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button"),
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus,
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`,
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus,
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`,
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    if (event.currentTarget.classList.contains('meraki-locale-mobile-trigger')) return;
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary"),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom",
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset - 1)}px`,
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    // 先移除 menu-open 类，让 header 切换与 drawer 关闭同步
    this.header.classList.remove("menu-open");
    document.body.classList.remove("menu-open");
    super.closeMenuDrawer(event, elementToFocus);
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`,
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false),
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest(".shopify-section").id.replace(
      "shopify-section-",
      "",
    );
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === "") {
        const productUrl = this.dataset.url.split("?")[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            const sourceQty = html.querySelector(
              ".quick-order-list-container",
            ).parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(
        `#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`,
      ),
    );
  }
}

customElements.define("bulk-modal", BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(
          true,
        ),
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe"),
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }

      // Workaround for safari iframe bug
      const formerStyle = deferredElement.getAttribute("style");
      deferredElement.setAttribute("style", "display: block;");
      window.setTimeout(() => {
        deferredElement.setAttribute("style", formerStyle);
      }, 0);
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));

    this.addPaginationBulletsListeners();

    // 注释掉自动跳转到变体特色媒体的逻辑
    // const mediaGallery = document.querySelector(`media-gallery`);
    // const selectMediaId = mediaGallery.dataset.selectMediaId;
    // const activeSlide = Array.from(this.sliderItems).find((slide) =>
    //   slide.dataset.mediaId.includes(selectMediaId),
    // );
    // if (activeSlide) this.goToSlide(activeSlide.dataset.index);

    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      if (!event.data.variant.featured_media) return;
      const mediaId = `${event.data.sectionId}-${event.data.variant.featured_media.id}`;
      const activeSlide = this.querySelector(`[data-media-id="${mediaId}"]`);
      if (activeSlide && activeSlide.dataset) {
        this.goToSlide(activeSlide.dataset.index);
      }
    });
  }

  addPaginationBulletsListeners() {
    const paginationBullets = this.querySelectorAll(
      ".slider-pagination-bullet",
    );
    paginationBullets.forEach((bullet, index) => {
      bullet.onclick = () => {
        this.goToSlide(index + 1);
      };
    });
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0,
    );
    if (this.sliderItemsToShow.length < 2) {
      this.sliderItemOffset = 0;
      return;
    }
    this.sliderItemOffset = this.sliderItemsToShow[0].clientWidth;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset,
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    const paginationBullets = this.querySelectorAll(
      ".slider-pagination-bullet",
    );
    paginationBullets.forEach((bullet, index) => {
      if (index + 1 === this.currentPage) {
        bullet.classList.add("is-active");
      } else {
        bullet.classList.remove("is-active");
      }
    });

    if (this.currentPage != previousPage) {
      const currentSliderItem = this.sliderItemsToShow[this.currentPage - 1];
      const prevSliderItem = this.sliderItemsToShow[this.currentPage - 2];
      const nextSliderItem = this.sliderItemsToShow[this.currentPage];
      this.loadingLazyImage(currentSliderItem)
      this.loadingLazyImage(prevSliderItem)
      this.loadingLazyImage(nextSliderItem)

      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        }),
      );
    }

    if (this.enableSliderLooping) return;

    const ric = window.requestIdleCallback || ((fn) => setTimeout(fn, 1));
    const cancelRic = window.cancelIdleCallback || clearTimeout;

    if (this.ricId) cancelRic(this.ricId);

    // 使用方式不变
    this.ricId = ric(() => {
      // 把isSlideVisible调用放到这里，避开首屏渲染关键期
      if (
        this.isSlideVisible(this.sliderItemsToShow[0]) &&
        this.slider.scrollLeft === 0
      ) {
        this.prevButton.setAttribute("disabled", "disabled");
      } else {
        this.prevButton.removeAttribute("disabled");
      }

      if (
        this.isSlideVisible(
          this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
        )
      ) {
        this.nextButton.setAttribute("disabled", "disabled");
      } else {
        this.nextButton.removeAttribute("disabled");
      }

      this.addPaginationBulletsListeners();
    });
  }

  loadingLazyImage(lazySliderItem) {
    if (lazySliderItem) {
      let lazyItemImgDom = lazySliderItem.querySelector(".image-magnify-hover")
      if (!lazyItemImgDom) {
        lazyItemImgDom = lazySliderItem.querySelector(".image-magnify-lightbox")
      }
      if (!lazyItemImgDom) {
        lazyItemImgDom = lazySliderItem.querySelector("img[data-lazy-src]")
      }
      const dataLazySrc = lazyItemImgDom?.getAttribute("data-lazy-src");
      const dataLazySrcset = lazyItemImgDom?.getAttribute("data-lazy-srcset");
      if (lazyItemImgDom && dataLazySrc) {
        lazyItemImgDom.setAttribute("src", dataLazySrc);
        lazyItemImgDom.removeAttribute("data-lazy-src");
        if (dataLazySrcset) {
          lazyItemImgDom.setAttribute("srcset", dataLazySrcset);
          lazyItemImgDom.removeAttribute("data-lazy-srcset");
        }
      }
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }

  goToSlide(page) {
    if (!this.sliderItemOffset || isNaN(this.sliderItemOffset)) {
      this.initPages();
    }
    let slideScrollPosition = 0;
    if (this.sliderItemOffset && !isNaN(this.sliderItemOffset)) {
      slideScrollPosition = (page - 1) * this.sliderItemOffset;
    }
    this.setSlidePosition(slideScrollPosition);
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow && this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector(".announcement-bar-slider");
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link"),
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this)),
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)",
      );
      this.reducedMotion.addEventListener("change", () => {
        if (this.slider.getAttribute("data-autoplay") === "true")
          this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        if (button) {
          button.addEventListener(
            "click",
            () => {
              this.announcementBarArrowButtonWasClicked = true;
            },
            { once: true },
          );
        }
      });
    }

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this),
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active",
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true,
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);

    const ricPlay = window.requestIdleCallback || ((fn) => setTimeout(fn, 1));
    const cancelRic = window.cancelIdleCallback || clearTimeout;
    if (this.ricPlay) cancelRic(this.ricPlay);
    // 使用方式不变
    this.ricPlay = ricPlay(() => {
      this.autoplay = setInterval(
        this.autoRotateSlides.bind(this),
        this.autoplaySpeed,
      );
    });
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow,
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow,
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    if (this.sliderItemsToShow && this.sliderItemsToShow.length) {
      this.sliderItemsToShow.forEach((item, index) => {
        const linkElements = item.querySelectorAll("a");
        if (index === this.currentPage - 1) {
          if (linkElements.length)
            linkElements.forEach((button) => {
              button.removeAttribute("tabindex");
            });
          item.setAttribute("aria-hidden", "false");
          item.removeAttribute("tabindex");
        } else {
          if (linkElements.length)
            linkElements.forEach((button) => {
              button.setAttribute("tabindex", "-1");
            });
          item.setAttribute("aria-hidden", "true");
          item.setAttribute("tabindex", "-1");
        }
      });
      this.wasClicked = false;
    }
  }

  applyAnimationToAnnouncementBar(button = "next") {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === "next" ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = "announcement-bar-slider--fade-in";
    const animationClassOut = "announcement-bar-slider--fade-out";

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext =
      (button === "next" && !isLastSlide) ||
      (button === "previous" && isFirstSlide);
    const direction = shouldMoveNext ? "next" : "previous";

    if (currentSlide && currentSlide.classList) {
      currentSlide.classList.add(`${animationClassOut}-${direction}`);
    }
    if (nextSlide && nextSlide.classList) {
      nextSlide.classList.add(`${animationClassIn}-${direction}`);
    }

    setTimeout(() => {
      if (currentSlide && currentSlide.classList) {
        currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      }
      if (nextSlide && nextSlide.classList) {
        nextSlide.classList.remove(`${animationClassIn}-${direction}`);
      }
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("change", (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === "SELECT" && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute("selected"))
        .removeAttribute("selected");
      target.selectedOptions[0].setAttribute("selected", "selected");

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest(".product-form__input")
        .querySelector("[data-selected-value] > .swatch");
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          swatchValue,
        );
        selectedDropdownSwatchValue.classList.remove("swatch--unavailable");
      } else {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          "unset",
        );
        selectedDropdownSwatchValue.classList.add("swatch--unavailable");
      }

      selectedDropdownSwatchValue.style.setProperty(
        "--swatch-focal-point",
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || "unset",
      );
    } else if (tagName === "INPUT" && target.type === "radio") {
      const selectedSwatchValue = target
        .closest(`.product-form__input`)
        .querySelector("[data-selected-value]");
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(
      this.querySelectorAll("select option[selected], fieldset input:checked"),
    ).map(({ dataset }) => dataset.optionValueId);
  }
}

customElements.define("variant-selects", VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: "0px 0px 400px 0px" },
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(
      `${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`,
    )
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations");

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (
          !this.querySelector("slideshow-component") &&
          this.classList.contains("complementary-products")
        ) {
          this.remove();
        }

        if (html.querySelector(".grid__item")) {
          this.classList.add("product-recommendations--loaded");
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define("product-recommendations", ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector(".icon");
  }

  connectedCallback() {
    document.addEventListener(
      "storefront:signincompleted",
      this.handleStorefrontSignInCompleted.bind(this),
    );
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define("account-icon", AccountIcon);

class BulkAdd extends HTMLElement {
  static ASYNC_REQUEST_DELAY = 250;

  constructor() {
    super();
    this.queue = [];
    this.setRequestStarted(false);
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });

    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, BulkAdd.ASYNC_REQUEST_DELAY);
  }

  sendRequest(queue) {
    this.setRequestStarted(true);
    const items = {};

    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter(
      (queueElement) => !queue.includes(queueElement),
    );

    this.updateMultipleQty(items);
  }

  setRequestStarted(requestStarted) {
    this._requestStarted = requestStarted;
  }

  get requestStarted() {
    return this._requestStarted;
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute("value");
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings.min_error.replace(
          "[min]",
          event.target.dataset.min,
        ),
      );
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings.max_error.replace(
          "[max]",
          event.target.max,
        ),
      );
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings.step_error.replace(
          "[step]",
          event.target.step,
        ),
      );
    } else {
      event.target.setCustomValidity("");
      event.target.reportValidity();
      event.target.setAttribute("value", inputValue);
      this.startQueue(index, inputValue);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
}

if (!customElements.get("bulk-add")) {
  customElements.define("bulk-add", BulkAdd);
}

class CartPerformance {
  static #metric_prefix = "cart-performance";

  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`;
    return performance.mark(`${metricName}:start`);
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`;
    const startMarker = performance.mark(`${metricName}:start`, {
      startTime: event.timeStamp,
    });

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(metricName, `${metricName}:start`, `${metricName}:end`);
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`;
    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(metricName, startMarker.name, `${metricName}:end`);
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`;
    const startMarker = performance.mark(`${metricName}:start`);

    callback();

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(metricName, `${metricName}:start`, `${metricName}:end`);
  }
}

class MerakiModal extends HTMLElement {
  constructor() {
    super();
    this.element = this.getElement();

    this.bindEvents();
  }

  getElement() {
    return {
      closeButton: this.querySelector('.meraki-media-modal__toggle')
    }
  }

  bindEvents() {
    this.element.closeButton.addEventListener('click', this.close.bind(this));
  }

  open() {
    this.setAttribute("open", "");
    this.scrollHidden();
  }

  close() {
    this.removeAttribute("open");
    this.scrollShow();
  }

  scrollHidden() {
    document.body.classList.add("overflow-hidden");
  }

  scrollShow() {
    document.body.classList.remove("overflow-hidden");
  }
}
customElements.define("meraki-modal", MerakiModal);

class MerakiCarouselSwitch extends HTMLElement {
  // 轮播切换，只会pc端切换
  // 示例(源码和样式)可以参考 sections\meraki-espresso-dual-boiler.liquid
  constructor() {
    super();
    this.DESKTOP_BREAKPOINT = 990;
    this.TRANSITION = 'cubic-bezier(0.45, 0, 0.73, 1)';
    this.window_innerWidth = window.innerWidth || document.documentElement.clientWidth
    this.carouselConfig = {
      itemWidth: this.window_innerWidth * 0.6 || 1068,
      gap: 20,
      initialOffset: 0,
      speed: 200
    };
    this.carouselState = {
      desktopReady: false,
      isAnimating: false,
      pendingDirection: null,
      resizeTimer: null
    };
    this.desktopSectionObserver = null;

    this.element = this.getElement();
    this.init();
  }
  getElement() {
    return {
      track: this.querySelector('.sell-points-track'),
      prevButton: this.querySelector('.sell-point-nav-prev'),
      nextButton: this.querySelector('.sell-point-nav-next'),
      originalSlides: Array.from(this.querySelectorAll('.sell-point-item'))
    }
  }
  init() {
    if (!this.element.track || !this.element.prevButton || !this.element.nextButton || this.element.originalSlides.length === 0) return;

    this.bindEvents();
  }
  bindEvents() {
    this.element.track.addEventListener('transitionend', this.handleTransitionEnd.bind(this));
    this.element.prevButton.addEventListener('click', this.movePrevDesktop.bind(this));
    this.element.nextButton.addEventListener('click', this.moveNextDesktop.bind(this));

    this.handleResize();
    window.addEventListener('resize', () => {
      clearTimeout(this.carouselState.resizeTimer);
      this.carouselState.resizeTimer = setTimeout(() => {
        this.carouselState.isAnimating = false;
        this.carouselState.pendingDirection = null;
        this.handleResize();
      }, 120);
    });
  }
  
  isDesktopView() {
    return this.window_innerWidth >= this.DESKTOP_BREAKPOINT;
  }

  getScaleFactor() {
    return Math.min(this.window_innerWidth / 1920, 1);
  }

  getSlideWidth() {
    return (this.carouselConfig.itemWidth + this.carouselConfig.gap) * this.getScaleFactor();
  }

  getBaseTranslate() {
    return this.carouselConfig.initialOffset * this.getScaleFactor();
  }

  applyTransform(value, animated) {
    this.element.track.style.transition = animated ? `transform ${this.carouselConfig.speed}ms ${this.TRANSITION}` : 'none';
    this.element.track.style.transform = `translate3d(${value}px, 0, 0)`;
    if (!animated) {
      this.element.track.getBoundingClientRect(); // 强制回流避免闪烁
    }
  }

  restoreOriginalOrder() {
    this.element.originalSlides.forEach(slide => {
      this.element.track.appendChild(slide);
    });
  }

  setNavAvailability(isEnabled) {
    [this.element.prevButton, this.element.nextButton].forEach(button => {
      if (isEnabled) {
        button.classList.remove('disabled');
        button.removeAttribute('disabled');
      } else {
        button.classList.add('disabled');
        button.setAttribute('disabled', 'disabled');
      }
    });
  }

  enableDesktopCarousel() {
    if (this.carouselState.desktopReady) {
      this.carouselState.isAnimating = false;
      this.carouselState.pendingDirection = null;
      this.applyTransform(this.getBaseTranslate(), false);
      this.setNavAvailability(true);
      return;
    }

    this.restoreOriginalOrder();
    this.carouselState.desktopReady = true;
    this.carouselState.isAnimating = false;
    this.carouselState.pendingDirection = null;
    this.setNavAvailability(true);
    this.applyTransform(this.getBaseTranslate(), false);
  }

  moveNextDesktop() {
    if (!this.carouselState.desktopReady || this.carouselState.isAnimating) return;
    this.carouselState.isAnimating = true;
    this.carouselState.pendingDirection = 'next';
    const target = this.getBaseTranslate() - this.getSlideWidth();
    this.applyTransform(target, true);
  }

  movePrevDesktop() {
    if (!this.carouselState.desktopReady || this.carouselState.isAnimating) return;

    const slides = this.element.track.querySelectorAll('.sell-point-item');
    if (!slides.length) return;

    const lastSlide = slides[slides.length - 1];
    this.element.track.insertBefore(lastSlide, slides[0]);

    const startPosition = this.getBaseTranslate() - this.getSlideWidth();
    this.applyTransform(startPosition, false);

    this.carouselState.isAnimating = true;
    this.carouselState.pendingDirection = 'prev';
    requestAnimationFrame(() => {
      this.applyTransform(this.getBaseTranslate(), true);
    });
  }

  handleTransitionEnd(event) {
    if (!this.carouselState.desktopReady || event.target !== this.element.track || !this.carouselState.pendingDirection) {
      return;
    }

    if (this.carouselState.pendingDirection === 'next') {
      const firstSlide = this.element.track.querySelector('.sell-point-item');
      if (firstSlide) {
        this.element.track.appendChild(firstSlide);
      }
    }

    this.carouselState.pendingDirection = null;
    this.carouselState.isAnimating = false;
    this.applyTransform(this.getBaseTranslate(), false);
  }

  handleResize() {
    if (this.isDesktopView()) {
      this.enableDesktopCarousel();
    }
  }
}
customElements.define("meraki-carousel-switch", MerakiCarouselSwitch);

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute("role", "button");
    summary.setAttribute(
      "aria-expanded",
      summary.parentNode.hasAttribute("open"),
    );

    if (summary.nextElementSibling && summary.nextElementSibling.getAttribute("id")) {
      summary.setAttribute("aria-controls", summary.nextElementSibling.id);
    }

    summary.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open"),
      );
    });

    if (summary.closest("header-drawer, menu-drawer")) return;
    summary.parentElement.addEventListener("keyup", onKeyUpEscape);
  });

  // Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
  try {
    document.querySelector(":focus-visible");
  } catch (e) {
    focusVisiblePolyfill();
  }

  // 初始加载：页面加载完成后检查一次
  if (window.merakiUtils.loadVisibleResource) window.merakiUtils.loadVisibleResource();

  function scrollCheck() {
    // if (window.merakiUtils.loadVisibleResource) {
    //   // 初始加载：页面加载完成后检查一次
    //   window.merakiUtils.loadVisibleResource();
    // }
    
    // if (window.merakiUtils.loadResourceAfterFirstScreen) window.merakiUtils.loadResourceAfterFirstScreen();
    isStickyBarVisible();
    scrollFloatingControlsVisible();
  }
  scrollCheck();
  // 节流后监听scroll/resize事件
  window.addEventListener('scroll', window.merakiUtils.throttle(scrollCheck));
  window.addEventListener('resize', window.merakiUtils.throttle(scrollCheck));
  if (window.merakiUtils.scrollToAnchor) {
    window.addEventListener('hashchange', window.merakiUtils.scrollToAnchor)
  }
  // if (window.merakiUtils.autoOpenRegionSelector) {
  //   window.merakiUtils.autoOpenRegionSelector()
  // }

  // 设置sticky bar弹出的条件
  function isStickyBarVisible() {
    const stickyBar = document.querySelector('#mrk-sticky-bar');
    if (stickyBar) {
      const bodyNode = document.body;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      const viewHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      const stickyBarHeight = stickyBar.clientHeight;
      
      // 允许 1px 误差（避免滚动精度问题）
      let isViewport = scrollTop > viewHeight;

      const mainProductNode = document.querySelector('product-info[id^="MainProduct-template"]');

      if (mainProductNode) {
        const rect = mainProductNode.getBoundingClientRect();
        isViewport = rect.bottom <= 0;
      }

      if (isViewport) {
        stickyBar.classList.add('show');
        bodyNode.style.paddingBottom = `${stickyBarHeight}px`;
      } else {
        stickyBar.classList.remove('show');
        bodyNode.style.paddingBottom = '0';
      }
    }
    
    if (!stickyBar) {
      // 旧版
      const stickyBarOld = document.querySelector('#sticky-bar');
      if (stickyBarOld) {
        const bodyNode = document.body;
        const stickyBarHeight = stickyBarOld.clientHeight;
        bodyNode.style.paddingBottom = `${stickyBarHeight}px`;
      }
    }
  }

  // 上报事件
  const reportBtnNodes = document.querySelectorAll('[mrk-btn-report]');
  reportBtnNodes.forEach((btnNode) => {
    btnNode.addEventListener('click', (event) => {
      event.preventDefault();
      const href = event.currentTarget.getAttribute('href');

      const bitRandomStr = window.merakiUtils.generateSecure16BitRandomStr();

      if (window.fbq) {
        const meta_session_view_pillar = window.merakiUtils.sessionStorageGet(window.merakiUtils.meta_session_view_pillar);
        if (!meta_session_view_pillar) {
          // window.fbq.push('trackShopify', window.merakiUtils.metaPixelId, 'Pillar_to_PDP_Click', {}, { eventID: bitRandomStr });
          window.fbq('trackCustom', 'Pillar_to_PDP_Click', {}, { eventID: bitRandomStr });
          window.merakiUtils.sessionStorageSet(window.merakiUtils.meta_session_view_pillar, bitRandomStr);
        }
      }
      if (window.gtag) {
        gtag('event', 'Pillar_to_PDP_Click', {
          'event_id': bitRandomStr,
          'page_url': window.location.href
        })
      }
      const timer = setTimeout(() => {
        if (href) {
          window.location.href = href;
        }
        clearTimeout(timer);
      }, 10);
    });
  });

  // 设置 subscription 组件中 input 元素是否输入了内容
  const subscriptionEmailNode = document.querySelector('#mrk-subscription-email');
  const subscriptionButtonNode = document.querySelector('#mrk-subscription-button');
  if (subscriptionEmailNode && subscriptionButtonNode) {
    setSubscriptionButtonDisabled();
    subscriptionEmailNode.addEventListener('input', (event) => {
      subscriptionEmailNode.setCustomValidity('');
      setSubscriptionButtonDisabled();
    });
    function setSubscriptionButtonDisabled() {
      const isEmpty = subscriptionEmailNode.value.trim() === '';
      if (isEmpty) {
        subscriptionButtonNode.disabled = true;
      } else {
        subscriptionButtonNode.disabled = false;
      }
    }

    const requiredMessage = subscriptionEmailNode.getAttribute('required-message');
    if (requiredMessage) {
      subscriptionEmailNode.addEventListener('invalid', e => {
        if (!subscriptionEmailNode.validity.valid) {
          subscriptionEmailNode.setCustomValidity(requiredMessage);
        } else {
          subscriptionEmailNode.setCustomValidity(""); // 重置自定义验证消息
        }
      });
    }
  }

  /**
   * 视频进入播放状态
   */
  const videoBlocks = document.querySelectorAll('video[videoInview]');
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.5,
  };
  const videoObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const video = entry.target;
      if (entry.isIntersecting) {
        video.play();
      } else {
        video.pause();
      }
    });
  }, observerOptions);
  videoBlocks.forEach((video) => {
    videoObserver.observe(video);
  });

  /**
   * 设置滚动悬浮控件弹出的条件 start
  */
  function scrollFloatingControlsVisible() {
    const scrollFloatingControls = document.querySelector('[scrollFloatingControls]');
    if (scrollFloatingControls) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      const viewHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      
      // 允许 1px 误差（避免滚动精度问题）
      let isViewport = scrollTop > viewHeight;
      
      if (isViewport) {
        scrollFloatingControls.classList.remove('hidden');
      } else {
        scrollFloatingControls.classList.add('hidden');
      }
    }
  }
  // 回到顶部
  const backToTopNode = document.querySelector('[backToTop]');
  if (backToTopNode) {
    backToTopNode.addEventListener('click', (event) => {
      event.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
  /**
   * 设置滚动悬浮控件弹出的条件 end
  */

  // 监听 klaviyo 表单事件
  const klaviyoSubmitEvent = ['SC9Nka', 'WEagvR'];
  const klaviyoIntervalMaps = {};
  window.addEventListener("klaviyoForms", function(e) {
    if (klaviyoSubmitEvent.includes(e.detail.formId)) {
      if (e.detail.type == 'submit') {
        // 清除之前的定时器
        let currentInterval = klaviyoIntervalMaps[e.detail.formId];
        if (currentInterval) {
          clearInterval(currentInterval.intervalId);
          currentInterval.intervalNum = 0;
        } else {
          klaviyoIntervalMaps[e.detail.formId] = {
            intervalId: null,
            intervalNum: 0
          };
          currentInterval = klaviyoIntervalMaps[e.detail.formId];
        }
        currentInterval.intervalId = setInterval(() => {
          const klaviyoFormNode = document.querySelector(`form[data-testid="klaviyo-form-${e.detail.formId}"] .klaviyo-emailinput`);
          if (currentInterval.intervalNum > 10) {
            clearInterval(currentInterval.intervalId);
          }
          if (!klaviyoFormNode) {
            // console.log('*********** 可以上报事件')
            clearInterval(currentInterval.intervalId);
          }
          currentInterval.intervalNum++;
        }, 1000);
      }
    }
  });
});